import _uniqueId from 'lodash/uniqueId'
import { useState } from 'react'

export const useChargesState = ({
  initialChargeKind,
  initialDescription,
  initialAmount
}) => {
  const [charges, setCharges] = useState([
    {
      id: _uniqueId('charge-'),
      chargeKind: initialChargeKind,
      description: initialDescription,
      amount: initialAmount
    }
  ])

  const handleChargeChange = (id, e) => {
    setCharges(prevCharges =>
      prevCharges.map(charge =>
        charge.id === id ? { ...charge, [e.target.name]: e.target.value } : charge
      )
    )
  }

  const handleAddCharge = () => {
    setCharges(prevCharges => [
      ...prevCharges,
      {
        id: _uniqueId('charge-'),
        chargeKind: initialChargeKind,
        description: '',
        amount: ''
      }
    ])
  }

  const handleRemoveCharge = id => {
    setCharges(prevCharges =>
      prevCharges.length > 1
        ? prevCharges.filter(charge => charge.id !== id)
        : prevCharges
    )
  }

  return { charges, handleChargeChange, handleAddCharge, handleRemoveCharge }
}
